import { useMemo } from "react";
import {
  TaskObjectNaming,
  DEFAULT_TASK_OBJECT_NAMING,
} from "@jugl-web/rest-api/tasks/types";
import { useTaskBoardsQuery } from "@jugl-web/domain-resources/tasks/hooks/useTaskBoardsQuery";

interface UseTaskObjectNamingProps {
  entityId: string;
  /**
   * Default (Task, Tasks) naming will be used if `boardId` is `null`
   */
  boardId: string | null;
}

export const useTaskObjectNaming = ({
  entityId,
  boardId,
}: UseTaskObjectNamingProps) => {
  const { getBoardByIdFromCache } = useTaskBoardsQuery({
    entityId,
  });

  const taskObjectNaming: TaskObjectNaming = useMemo(() => {
    if (!boardId) {
      return DEFAULT_TASK_OBJECT_NAMING;
    }

    const board = getBoardByIdFromCache(boardId);

    return {
      singular:
        board?.taskObjectNaming.singular || DEFAULT_TASK_OBJECT_NAMING.singular,
      plural:
        board?.taskObjectNaming.plural || DEFAULT_TASK_OBJECT_NAMING.plural,
    };
  }, [boardId, getBoardByIdFromCache]);

  return taskObjectNaming;
};
